import { render, staticRenderFns } from "./RmaResponsibleBoard.vue?vue&type=template&id=33b14730&scoped=true&"
import script from "./RmaResponsibleBoard.vue?vue&type=script&lang=js&"
export * from "./RmaResponsibleBoard.vue?vue&type=script&lang=js&"
import style0 from "./RmaResponsibleBoard.vue?vue&type=style&index=0&id=33b14730&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33b14730",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VProgressLinear } from 'vuetify/lib/components/VProgressLinear';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VIcon,VProgressLinear,VSelect,VSpacer})
